export function toPayload(action) {
    return action.payload;
}
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/effects/src/util.js
// module id = 647
// module chunks = 4